<template>
  <div class="round">
    <div class="content">
      <player></player>
    </div>
    <div class="footer">
      <div>教室监控</div>
      <div><img src="../assets/images/device/qp.png" style="width: 24px" title="点击全屏" @click="fullScreen"/></div>
    </div>
  </div>
</template>

<script>
import Player from './Player'

export default {
  name: 'MyVideo',
  components: { Player },
  methods: {
    fullScreen () {
      this.$hub.$emit('fullscreen', true)
    }
  }
}
</script>

<style scoped lang="less">
.round {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 17px 2px rgba(219, 219, 219, 0.3);
  border-radius: 8px;
  height: 260px;
  min-width: 230px;
  max-width: 24%;
  display: flex;
  position: relative;
  flex-direction: column;
  .content {
    width: 100%;
    height: 195px;
    mask-image: radial-gradient(circle, white 100%, black 100%);
    transform: rotate(0.000001deg);
    border-radius: 8px 8px 0px 0px;
    overflow: hidden;
  }
  .footer {
    display: flex;
    flex: 1;
    justify-content: space-between;
    align-items: center;
    padding: 0px 20px;
    font-size: 18px;
    font-weight: 500;
    color: rgba(38, 38, 38, 1);
    & img {
      cursor: pointer;
    }
  }
}
</style>
